import { render, staticRenderFns } from "./DashboardPhase5.vue?vue&type=template&id=a430aa3a&scoped=true&"
import script from "./DashboardPhase5.vue?vue&type=script&lang=js&"
export * from "./DashboardPhase5.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPhase5.vue?vue&type=style&index=0&id=a430aa3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a430aa3a",
  null
  
)

export default component.exports